import clsx from 'clsx';
import styles from './IconButton.module.css';
import { TertiaryActionButton } from '../tertiary-action/TertiaryActionButton';

export function IconButton({
  ariaLabel,
  children,
  className = '',
  onClick,
  onMouseDown,
  size = 'sm',
  variant = 'default',
  type = 'button',
  disabled = false,
  ...rest
}) {
  const sizeClass = size === 'md' ? styles.size32 : styles.size24;

  return (
    <TertiaryActionButton
      {...rest}
      ariaLabel={ariaLabel}
      className={clsx(styles.root, sizeClass, className)}
      onClick={onClick}
      onMouseDown={onMouseDown}
      variant={variant}
      type={type}
      disabled={disabled}
    >
      {children}
    </TertiaryActionButton>
  );
}
